import { useCallback } from 'react';
import useHttp from '../http/useHttp';
import { useNavigate } from 'react-router';
import useUI from '../context/useUI';

export default function usePostCustodian() {
  const navigate = useNavigate();
  const { showSnackbar } = useUI();
  const { postDataResponse, postData } = useHttp();

  const save = useCallback(async (model: any) => {
    const result = await postData('Entity/save', model);
    if (result && result.data && !isNaN(result.data)) {
      showSnackbar(['Entity created successfully!'], 'success');
      navigate(`/entities`);
    }
  }, []);

  return { data: postDataResponse?.data ?? null, save };
}
